<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<div class="clearfix topper">
			<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
			<div class="col-xs-12 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb//best_ensemble_cast.jpg" alt="Three Billboards"></div>
		</div>
		<div class="clearfix grid">
			<production-quote id="bestPictureProdQuote1" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote1"></production-quote>
			<div class="col-xs-12 col-md-6 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_110_CompanyOfCharacters_TXTD_NoSlate.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_110_CompanyOfCharacters_TXTD_NoSlate.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_110_CompanyOfCharacters_TXTD_NoSlate.webm" type='video/webm' />
				</video>
			</div>
			<production-quote id="bestPictureProdQuote2" class="col-xs-12 col-md-6 col-md-push-6 no-pad" :prodQuote="productionQuote2"></production-quote>
			<div class="col-xs-12 col-md-6 col-md-pull-6 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_106_TownOfCharacters_TXTD_NoSlate-01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_106_TownOfCharacters_TXTD_NoSlate.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_106_TownOfCharacters_TXTD_NoSlate_1.webm" type='video/webm' />
				</video>
			</div>
			<production-quote id="bestPictureProdQuote3" class="col-xs-12 no-pad" :prodQuote="productionQuote3"></production-quote>
		</div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import SliderImage from '../../components/SliderImage';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-ensemble',
	data: function() {
		return {
			heroContent: {
				"image": "best-ensemble-3b-lg",
				"mobileImage": "best-ensemble-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "Best Ensemble",
				"subHeader": [''],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'Best Original Screenplay',
				clickThruPath: ''
			},
			criticSlider1: [
				{
					text: 'The cast turns in the best ensemble work of any movie this year.',
					author: '- CHICAGO SUN-TIMES'
				}
			],
			productionQuote1: {
				text: "All the performances are first-rate.",
				author: "- Peter Travers, ROLLING STONE"
			},
			productionQuote2: {
				text: "The cast is superb, with Woody Harrelson and Sam Rockwell right up there with Ms. McDormand in the pantheon of unforgettable performances.",
				author: "– Joe Morgenstern, THE WALL STREET JOURNAL"
			},
			productionQuote3: {
				text: "Working with the rest of the cast was almost like doing theater – we did a lot of talking about their characters and character choices. It’s really a proper ensemble piece.",
				author: "- Martin McDonagh"
			}

		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		}
	}
}
</script>
<style lang="scss">
	.bestEnsemble {
		.category-title {
			opacity: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// BestEnsemble.vue?8f1c8fe0